import { ReactElement, ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmarkCircle } from '@fortawesome/free-regular-svg-icons';
import { hooks as commonHooks } from '@sitebuilder/common';
import { types as coreTypes } from '@sitebuilder/core';
import { actionCreators } from '../../../reducers/templateEditor';
import { resourceIconSvg } from '../../../assets/images';
import AddNewLocaleForm from './AddNewLocaleForm';
import AddNewResourceForm from './AddNewResourceForm';

interface SiteResourcesRightSidebarProps {
    addNewLocale: boolean;
    resources: coreTypes.Resource | null;
    filteredResources?: coreTypes.Resource | null;
    resourcesType: string;
    addNewResource?: boolean;
    isShowCloseIcon?: boolean;
}

const SiteResourcesRightSidebar = (
    props: SiteResourcesRightSidebarProps
): ReactElement & ReactNode => {
    const {
        addNewLocale,
        addNewResource,
        resources,
        resourcesType,
        filteredResources,
        isShowCloseIcon,
    } = props;
    const i18n = commonHooks.useLocalization();
    const dispatch = useDispatch();
    const onClickClose = () => {
        dispatch(actionCreators.setPageAction(''));
    };
    return (
        <>
            {(addNewLocale || addNewResource) && (
                <div className="resources-side-bar-header-cont">
                    <div className="resources-side-bar-header">
                        <img
                            className={'resources-icon'}
                            src={resourceIconSvg}
                            alt="resources-icon"
                        />
                        <span className={'resources-title'}>{i18n.t('resources_title')}</span>
                    </div>
                    {isShowCloseIcon ? (
                        <button className="close-button" onClick={onClickClose}>
                            <FontAwesomeIcon icon={faXmarkCircle} />
                        </button>
                    ) : (
                        <></>
                    )}
                </div>
            )}
            {addNewLocale && !addNewResource && (
                <AddNewLocaleForm resources={resources} resourcesType={resourcesType} />
            )}
            {addNewResource && !addNewLocale && (
                <AddNewResourceForm
                    resources={resources}
                    resourcesType={resourcesType}
                    filteredResources={filteredResources}
                />
            )}
        </>
    );
};
export default SiteResourcesRightSidebar;
